/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { AuditChiamataErroriExportDTO } from '../model/models';
import { AuditChiamataListFilter } from '../model/models';
import { ExceptionResponseDTO } from '../model/models';
import { GetProfiloServizio409Response } from '../model/models';
import { GetProfiloServizio422Response } from '../model/models';
import { Pageable } from '../model/models';
import { PagedModelAuditChiamataDTO } from '../model/models';


import { Configuration }                                     from '../configuration';


export interface ExportAuditChiamateErroriRequestParams {
    filter: AuditChiamataListFilter;
}

export interface ListAuditChiamateRequestParams {
    filter: AuditChiamataListFilter;
    pageable: Pageable;
}


export interface AuditChiamateServiceInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * Export delle chiamate HTTP finite in errore, raggruppate (SUPERADMIN).
     * Stessi filtri della lista, ristretti alle chiamate con status &gt;&#x3D; 400. Le raggruppa per verbo, operazione, path (con gli identificativi sostituiti da {id}) e status e restituisce fino a 500 gruppi, i piu\&#39; frequenti prima, ciascuno con le 5 chiamate piu\&#39; recenti: path, query, durata, user agent, corpi di richiesta e risposta. Niente actor_user_id, actor_snapshot ne\&#39; indirizzo IP, e l\&#39;eco dei filtri omette attore/actor_user_id; i corpi pero\&#39; possono contenere dati personali oscurati solo in parte. \&#39;troncato\&#39; vale true se i gruppi sono piu\&#39; di quelli esportati.
     * @endpoint get /api/v1/gestione/audit-chiamate/export-errori
* @param requestParameters
     */
    exportAuditChiamateErrori(requestParameters: ExportAuditChiamateErroriRequestParams, extraHttpRequestParams?: any): Observable<AuditChiamataErroriExportDTO>;

    /**
     * Lista paginata delle chiamate HTTP registrate (SUPERADMIN).
     * Filtri opzionali: q (path e nome operazione), metodo_http, status_code, operazione, actor_user_id, attore (nome o email di chi ha agito, ricerca parziale), actor_type, solo_modifiche, da/a sull\&#39;istante della chiamata (UTC). Ordinamento predefinito: request_time DESC, size 20. Password, token e segreti sono oscurati del tutto prima della scrittura, i dati personali (codice fiscale, email, telefono, IBAN, ...) in parte. I corpi di richiesta e risposta sono restituiti decifrati ma NON sono filtrabili: a riposo sono cifrati in modo non deterministico, quindi non esiste un valore stabile su cui costruire una condizione. Le letture riuscite spariscono dopo la finestra di ritenzione configurata; modifiche ed errori restano.
     * @endpoint get /api/v1/gestione/audit-chiamate
* @param requestParameters
     */
    listAuditChiamate(requestParameters: ListAuditChiamateRequestParams, extraHttpRequestParams?: any): Observable<PagedModelAuditChiamataDTO>;

}
